<template>
    <div>
        <custom-radio
            v-if="!child || child.appearance_status?.type === 'check_in'"
            custom-class="colorful daily-report-types mt-3"
            v-model="selectedReportType"
            :items="reportTypes"
            type="grid"/>

<!--        <basic-button-->
<!--            v-if="child?.appearance_status != null && child.appearance_status.type !== 'pending'"-->
<!--            cls="mt-3 m-1 btn-fluid align-items-center btn btn-warning"-->
<!--            icon="fi-rr-list-timeline"-->
<!--            :text="trans('general.child.view_today_reports_short')"-->
<!--            @click="viewChildReport()"/>-->
    </div>
</template>

<script>
import CustomRadio from "../../../theme/molecules/CustomRadio.vue";
import {REPORT_TYPE} from "../../../services/Defaults";
import Nap from "../molecules/TypeForms/Nap.vue";
import Bathroom from "../molecules/TypeForms/Bathroom.vue";
import Outside from "../molecules/TypeForms/Outside.vue";
import Mood from "../molecules/TypeForms/Mood.vue";
import Meal from "../molecules/TypeForms/Meal.vue";
import Hydration from "../molecules/TypeForms/Hydration.vue";
import Activity from "../molecules/TypeForms/Activity.vue";
import Health from "../molecules/TypeForms/Health.vue";
import {eventBus} from "../../../services/EventBus";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "SelectReportType",
    components: {
        CustomRadio, BasicButton
    },
    props: {
        child: {
            type: Object|Boolean,
            required: false
        }
    },
    data() {
        return {
            selectedReportType: null,
            reportTypes: [
                {
                    value: REPORT_TYPE.NAP,
                    component: Nap,
                    text: trans('general.module.report.type.nap'),
                    icon: 'fi-rr-moon',
                    color: 'text-black',
                    cls: 'bg-gray-200'
                },
                {
                    value: REPORT_TYPE.BATHROOM,
                    component: Bathroom,
                    text: trans('general.module.report.type.bathroom'),
                    icon: 'fi-rr-toilet-paper-blank',
                    color: 'text-dark-sky',
                    cls: 'bg-light-sky'
                },
                {
                    value: REPORT_TYPE.OUTSIDE,
                    component: Outside,
                    text: trans('general.module.report.type.outside'),
                    icon: 'fi-rr-leaf',
                    color: 'text-dark-green',
                    cls: 'bg-light-green'
                },
                {
                    value: REPORT_TYPE.ACTIVITY,
                    component: Activity,
                    text: trans('general.module.report.type.activity'),
                    icon: 'fi-rr-triangle',
                    color: 'text-dark-pink',
                    cls: 'bg-light-pink'
                },
                {
                    value: REPORT_TYPE.MOOD,
                    component: Mood,
                    text: trans('general.module.report.type.mood'),
                    icon: 'fi-rr-meh',
                    color: 'text-purple',
                    cls: 'bg-light-purple'
                },
                {
                    value: REPORT_TYPE.MEAL,
                    component: Meal,
                    text: trans('general.module.report.type.meal'),
                    icon: 'fi-rr-apple-whole',
                    color: 'text-dark-orange',
                    cls: 'bg-light-orange'
                },
                {
                    value: REPORT_TYPE.HEALTH,
                    component: Health,
                    text: trans('general.module.report.type.health'),
                    icon: 'fi-rr-stethoscope',
                    color: 'text-dark-red',
                    cls: 'bg-light-red'
                },
                {
                    value: REPORT_TYPE.HYDRATION,
                    component: Hydration,
                    text: trans('general.module.report.type.hydration'),
                    icon: 'fi-rr-glass',
                    color: 'text-dark-blue',
                    cls: 'bg-light-blue'
                },
                {
                    value: REPORT_TYPE.DEVELOPMENT,
                    text: trans('general.quick_call.observe'),
                    icon: 'fi-rr-puzzle',
                    color: 'text-dark-green',
                    cls: 'bg-light-green'
                },
            ]
        };
    },
    watch: {
        selectedReportType: function (val) {
            this.$emit('report-type-selected', val);
        }
    },
    methods: {
        selectReportType(reportType) {
            this.selectedReportType = reportType;
        },
        // viewChildReport() {
        //     this.$emit('close');
        //     eventBus.$emit('view-child-report', {childId: this.child?.id});
        // },
    }
}
</script>
